var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 28.437498092651367,
    height: 32.5,
    viewBox: "0 0 28.437498092651367 32.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,6.5C26,5.8269,26.5457,5.28125,27.2187,5.28125C27.8918,5.28125,28.4375,5.8269,28.4375,6.5L28.4375,28.0312C28.4375,30.4992,26.4367,32.5,23.9688,32.5L4.46875,32.5C2.00078,32.5,0,30.4992,0,28.0312L0,4.46875C0,2.00078,2.00078,0,4.46875,0L27.2187,0C27.8918,0,28.4375,0.545653,28.4375,1.21875C28.4375,1.89185,27.8918,2.4375,27.2187,2.4375L4.46875,2.4375C3.34692,2.4375,2.4375,3.34692,2.4375,4.46875L2.4375,28.0313C2.4375,29.1531,3.34692,30.0625,4.46875,30.0625L23.9688,30.0625C25.0906,30.0625,26,29.1531,26,28.0313L26,6.5ZM7.71875,13.4062C7.04565,13.4062,6.5,12.8606,6.5,12.1875C6.5,11.5144,7.04565,10.9688,7.71875,10.9688L20.7188,10.9688C21.3918,10.9688,21.9375,11.5144,21.9375,12.1875C21.9375,12.8606,21.3918,13.4062,20.7188,13.4062L7.71875,13.4062ZM7.71875,19.9062C7.04565,19.9062,6.5,19.3606,6.5,18.6875C6.5,18.0144,7.04565,17.4688,7.71875,17.4688L15.8438,17.4688C16.5168,17.4688,17.0625,18.0144,17.0625,18.6875C17.0625,19.3606,16.5168,19.9062,15.8438,19.9062L7.71875,19.9062Z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.020c3e12425bd526fce82cb01e13ae99.svg";
export { ForwardRef as ReactComponent };